import { API_REQUEST } from "../..";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminContentAPI, adminProjectAPI, updateProjectStatusEndPointURL } from "../../../../routes/apiurls";

export const fetchContent = createAsyncThunk("fetch-content", async () => {
  try {
    const response = await API_REQUEST({
      url: adminContentAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) { }
});


